angular.module('satv.media')
.directive('satvMediaDownloadFrame', ['$rootScope', function($rootScope) {
    return {
        restrict: 'AE',
        link: function($scope, element, attr, ctrl) {
            $rootScope.$on('MEDIA_DOWNLOAD_READY', function(e, download) {
                var iFrame = element.find("iframe");
                if (!(iFrame && iFrame.length > 0)) {
                    iFrame = angular.element('<iframe style="position:fixed;display:none;top:-1px;left:-1px;"/>');
                    element.append(iFrame);
                }
                iFrame.attr("src", download._links.download);
            });
        }
    };
}]);



// WEBPACK FOOTER //
// ./vendor/sonyatv/mediaclientbundle/Resources/js/angular/directives/downloadFrame.js